import { render, staticRenderFns } from "./newNarcoticsLog.vue?vue&type=template&id=5f7f4cbf&scoped=true"
import script from "./newNarcoticsLog.vue?vue&type=script&lang=js"
export * from "./newNarcoticsLog.vue?vue&type=script&lang=js"
import style1 from "./newNarcoticsLog.vue?vue&type=style&index=1&id=5f7f4cbf&prod&lang=css"
import style2 from "./newNarcoticsLog.vue?vue&type=style&index=2&id=5f7f4cbf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f7f4cbf",
  null
  
)

export default component.exports